export default "__VITE_ASSET__Bmv0qkAe__"